import {io} from 'socket.io-client';
export const socketInit=()=>{
    const options={
        'force new connection':true,
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: Infinity,
        timeout: 10000,
        transports: ['websocket', 'polling'],
    }
    return io('https://signage.leedoit.com', options);
}
